export default __webpack_public_path__ + "static/media/winter1.74ce9530.jpg";